import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MapApp from './MapApp';
import RafflePage from './components/RafflePage';
import './styles/globals.css';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Main map route */}
        <Route path="/" element={<MapApp />} />
        
        {/* Single raffle route - location selected via dropdown */}
        <Route path="/raffle" element={<RafflePage />} />
        
        {/* Legacy routes - redirect old location-based URLs to new form */}
        <Route path="/raffle/:location" element={<RafflePage />} />
        
        {/* Catch all route - redirect to main map */}
        <Route path="*" element={<MapApp />} />
      </Routes>
    </Router>
  );
};

export default App;